<div class="accept-mobile-wrapper cookies" fxLayout="column">
  <div class="accept-header " fxLayout="row">
    <h3>{{ 'COOKIES.TITLE' | translate }}</h3>
  </div>
  <div class="terms-area" fxLayout="row">
    <!-- <mat-form-field fxFlex>
        <textarea matInput readonly name="" id="" rows="10"  style="width: 100%">
       {{termsText}}
     </textarea>
    </mat-form-field> -->

  </div>
  <div class="actions" fxLayout="row" fxLayoutAlign="space-around">
    <!-- <button mat-raised-button color="primary" (click)="approve()">מאשר תנאים</button> -->
    <button class="Dialog" mat-raised-button color="danger" (click)="close()">{{ 'COOKIES.ACCEPT' | translate }}</button>
  </div>

</div>
